function geolocate(map) {
  var geocoder = new google.maps.Geocoder();

  if (!map) {
    return;
  }

  var address = map.dataset.addressSetting;

  var deferred = new Promise((resolve, reject) => {
    geocoder.geocode({ address: address }, function(results, status) {
      if (status !== google.maps.GeocoderStatus.OK) {
        reject(status);
      }
      resolve(results);
    });
  });

  return deferred;
}
// Initialize and add the map
let map;

async function initMap() {
  geolocate(document.querySelector('[data-map]')).then(async (results) =>  {
    var mapOptions = {
      zoom: 14,
      backgroundColor: 'none',
      center: results[0].geometry.location,
      draggable: false,
      clickableIcons: false,
      scrollwheel: false,
      disableDoubleClickZoom: true,
      disableDefaultUI: true
    }
    // Request needed libraries.
    //@ts-ignore
    const { Map } = await google.maps.importLibrary("maps");
    
    // The map, centered at Uluru
    map = new Map(document.querySelector("[data-map]"), mapOptions );
    var marker = new google.maps.Marker({
      map: map,
      position: map.getCenter()
    });
    
  })
}

initMap();